<template>
	<div class="section_characterCategory">
		<Splide
			:has-track="false"
			class="characterCategory_wrap"
			:options="programSplideOptions"
			@splide:mounted="updateVideosProgress"
		>
			<SplideTrack>
				<!-- <SplideSlide
					v-for="(item, index) in props.masterList.master_list_onsub"
					:key="`${index}`"
					class="characterCategory_item"
					:class="item.master_pk === Number(masterPk) && 'on'"
					@click.stop="onChangeMaster(item)"
				>
					<img :src="item.file_path" class="item_img" alt="대가 일러스트" loading="lazy" />
					<div class="item_content">
						<p class="content_name">{{ item.master_name }}</p>
						<p v-if="!props.all" class="content_subOn">구독중</p>
					</div>
				</SplideSlide>
				<template v-if="!props.all"> -->
				<SplideSlide
					v-for="(item, index) in props.masterList.master_list_nosub"
					:key="`${index}`"
					class="characterCategory_item"
					:class="item.master_pk === Number(masterPk) && 'on'"
					@click.stop="onChangeMaster(item)"
				>
					<img :src="item.file_path" class="item_img" alt="대가 일러스트" loading="lazy" />
					<div class="item_content">
						<p class="content_name">{{ item.master_name }}</p>
						<!-- <p class="content_subOff">미구독</p> -->
					</div>
				</SplideSlide>
				<!-- </template> -->
			</SplideTrack>
			<div class="splide_footer">
				<div class="splide__arrows">
					<button class="splide__arrow splide__arrow--prev">
						<arrowPrevIcon />
					</button>

					<span class="divider"></span>
					<button class="splide__arrow splide__arrow--next">
						<arrowPrevIcon />
					</button>
				</div>
			</div>
		</Splide>
	</div>
</template>
<script setup lang="ts">
// core
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Splide as SplideType } from '@splidejs/splide';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';

// api
import { GetMasterListData, masterListSubscription } from '@/api/master';
// asset
import arrowPrevIcon from '@/assets/img/common/arrow_next.svg?component';

// -----variable-----
const props = defineProps<{
	masterList: GetMasterListData;
	all?: boolean;
}>();
const emit = defineEmits(['update:masterDetail', 'update:masterEvent', 'update:masterPk', 'update:subYn']);

const route = useRoute();
const router = useRouter();

const swiperComponent = ref();

const masterPk = ref(0);
const routePk = computed(() => {
	return route.query.masterPk;
});

const programSplideOptions = {
	rewind: false,
	// type: 'loop',
	arrow: false,
	autoplay: 'pause',
	autoWidth: true,
	pauseOnHover: true,
	dragMinThreshold: 0,
	padding: '0rem',
	perMove: 4,
	breakpoints: {
		1024: {
			padding: '2rem',
		},
		555: {
			perMove: 3,
			padding: '2rem',
		},
		375: {
			perMove: 2,
			padding: '2rem',
		},
	},
};

// -----function-----
// 해당 마스터로 슬라이드 이동
const updateVideosProgress = (splide: SplideType) => {
	swiperComponent.value = splide;

	// master_list_onsub에서 일치하는 항목 찾기
	for (const [index, item] of props.masterList.master_list_onsub.entries()) {
		if (String(item.master_pk) === routePk.value) {
			swiperComponent.value.go(index);
			return;
		}
	}

	// master_list_onsub에서 찾지 못한 경우에만 master_list_nosub 확인
	for (const [index, item] of props.masterList.master_list_nosub.entries()) {
		if (String(item.master_pk) === routePk.value) {
			swiperComponent.value.go(index);
			return;
		}
	}
};

// 대가 변경 시 함수
const onChangeMaster = (item: masterListSubscription) => {
	masterPk.value = item.master_pk;
	router.replace({
		query: {
			masterPk: item.master_pk,
		},
	});
	emit('update:masterPk', item.master_pk);
};

// -----composition-----
watch(
	() => routePk.value,
	() => {
		if (routePk.value) {
			masterPk.value = Number(routePk.value);
		} else if (props.masterList.master_list_onsub.length > 0) {
			masterPk.value = props.masterList.master_list_onsub[0].master_pk;
		} else {
			masterPk.value = props.masterList.master_list_nosub[0].master_pk;
		}
	},
	{
		immediate: true,
	}
);
</script>

<style lang="scss" scoped>
.section_characterCategory {
	:deep(.characterCategory_wrap) {
		padding-bottom: var(--space-xxx-large);

		.characterCategory_item {
			height: max-content;
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 1rem;
			background-color: var(--color-bg-mid);
			border-radius: 0.8rem;
			padding: 2rem 0;
			border: 1px solid var(--color-base-mid);
			cursor: pointer;

			.item_img {
				width: 5.8rem;
				height: 5.8rem;
				object-fit: contain;
			}
			.item_content {
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 0.4rem;
				font-size: var(--font-s-mid);
				font-weight: var(--font-w-semi-bold);
				line-height: normal;
				.content_subOff {
					color: var(--color-danger);
				}
				.content_subOn {
					color: var(--color-secondary-Blue);
				}
			}
		}
		.splide_footer {
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			display: flex;
			align-items: center;
			gap: var(--space-large);
			width: 100%;
			justify-content: flex-end;
			padding-right: 2rem;
			&-full {
				@extend .splide_footer;
				max-width: 1280px;
				width: calc(100% - 40px);
			}
			.splide__arrows {
				display: flex;
				gap: var(--space-mid);
				align-items: center;
				.divider {
					content: '';
					display: inline-block;
					width: 1px;
					height: 1.2rem;
					background-color: var(--color-base-mid);
				}
				.splide__arrow {
					position: relative;
					transform: none;
					left: unset;
					right: unset;
					background-color: transparent;
					opacity: 1;
					width: 2.2rem;
					height: 2.2rem;
					svg {
						width: 100%;
						height: 100%;
					}
					&:disabled {
						svg {
							:deep(path) {
								fill: var((--color-base-disabled));
							}
						}
					}
				}
			}
		}
		.splide__pagination {
			display: none;
		}
		.splide__slide {
			width: 16.25rem;
			cursor: pointer;
			margin-right: 1rem;
			.imageBox {
				width: 100%;
				height: 20rem;
				margin-bottom: var(--space-mid);
				img {
					background-color: var(--color-base-dark);
					width: 100%;
					height: 100%;
					object-fit: cover;
					object-position: center;
				}
			}
			.textBox {
				h4 {
					font-size: var(--font-size-large);
					font-weight: var(--font-w-mid);
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					margin-bottom: var(--space-xx-small);
				}
			}
		}
		.on {
			border: 1px solid var(--color-primary);
		}
	}
}
</style>
